export default __webpack_public_path__ + "static/media/6-small.cb875cd8.png";